module.exports = __webpack_public_path__ + "src/assets/animations/foxglove.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/animations/foxglove.png
// module id = ./src/assets/animations/foxglove.png
// module chunks = 0